import { useIntersectionObserver } from 'usehooks-ts'

type Props = {
  children: React.ReactNode
}

export const FadeIn: React.FC<Props> = ({ children }) => {
  const [ref, isIntersecting] = useIntersectionObserver({ threshold: 0.08, freezeOnceVisible: true })
  const style = {
    opacity: isIntersecting ? 1 : 0,
    transform: isIntersecting ? 'translateY(0)' : 'translateY(18px)',
    transition: `opacity 0.55s ease-out, transform 0.55s ease-out`,
  }

  return (
    <div ref={ref} style={style}>
      {children}
    </div>
  )
}
